import { render, staticRenderFns } from "./IRLModal.vue?vue&type=template&id=29c54b23&scoped=true"
import script from "./IRLModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IRLModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IRLModal.vue?vue&type=style&index=0&id=29c54b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c54b23",
  null
  
)

export default component.exports